import axios from 'axios';

// const API_URL = 'http://localhost:8080/api/auth/';
const API_URL = 'https://eflex-api-prod.azurewebsites.net/api/auth/';

class AuthService {

  async login(user) {
    const response = await axios
      .post(API_URL + 'signin', {
        email: user.email,
        password: user.password
      });
    if (response.data.accessToken) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('EflexToken', response.data.accessToken)
    }
    return response.data;
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('EflexToken');
  }

  async token(code, headers) {
    console.log("HEADERS", headers, code)
    return axios.post('https://eflex-api-prod.azurewebsites.net/api/auth/confirm-account', {
      otp: code
    }, headers)
  }

  profile(headers, user) {
    return axios.put('https://eflex-api-prod.azurewebsites.net/api/user/profile', user, headers)
  }

  getProfile(headers) {
    return axios.get('https://eflex-api-prod.azurewebsites.net/api/user/profile', headers)
  }

  register(user) {
    return axios.post('https://eflex-api-prod.azurewebsites.net/api/auth/signup', {
      email: user.email,
      password: user.password,
      resetPasswordToken: user.resetPasswordToken,
      role: user.role,
      companyName: user.companyName,
      companyAddress: user.companyAddress,
      buildingNumber: user.buildingNumber,
      city: user.city,
      postcode: user.postcode,
      countryCode: user.countryCode,
      phoneNumber: user.phoneNumber
    });
  }

  async getToken(user) {
    const response = await axios.post(API_URL + 'send-email', {
      email: user.email
    });
    if (response.data.accessToken) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  }

  async forgotPassword(user) {
    return axios.post(API_URL + 'forgot-password', {
      email: user.email
    });
    /* const response = await axios.post(API_URL + 'forgot-password', {
      email: user.email
    });
    if (response.data.accessToken) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data; */
  }

  async resetPassword(user) {
    return axios.post(API_URL + 'reset-password', {
      password: user.password,
      resetPasswordToken: user.resetPasswordToken
    });
    /* const response = await axios.post(API_URL + 'reset-password', {
      resetPasswordToken: user.resetPasswordToken,
      password: user.password
    });
    if (response.data.accessToken) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data; */
  }

  async changePassword(user) {
    return axios.post(API_URL + 'change-password', {
      email: user.email,
      password: user.password,
    });
  }
}

export default new AuthService();
